import { PayloadAction } from '@reduxjs/toolkit'
import { User } from '@types'
import { getRecoveredPendingStudyService, putCaseInfo } from '@http/analystService'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import {
  getRecoveredRejectedCases,
  getRecoveredRejectedCasesFailed,
  getRecoveredRejectedCasesSuccess,
  PatchRecoveredRejectedPayload,
  patchRecoveredRejectedInfo
} from './analystRejectedSlice'

export function* getRecoveredRejectedCasesSaga() {
  const { cocap } = yield select(selectCredentials)
  try {
    const cases: User[] = yield call(getRecoveredPendingStudyService, cocap)
    yield put(getRecoveredRejectedCasesSuccess(cases))
  } catch (e) {
    yield put(getRecoveredRejectedCasesFailed(JSON.stringify(e)))
  }
}

export function* updateRecoveredRejectedInfoSaga({ payload }: PayloadAction<PatchRecoveredRejectedPayload>) {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const response: { message: string } = yield call(putCaseInfo, cocap, userId, payload)
    let cases = []
    if (response.message === 'success') {
      cases = yield call(getRecoveredPendingStudyService, cocap)
    }
    yield put(getRecoveredRejectedCasesSuccess(cases))
  } catch (e) {
    yield put(getRecoveredRejectedCasesFailed(JSON.stringify(e)))
  }
}

export default function* analystRejectedSaga() {
  yield takeEvery(getRecoveredRejectedCases.type, getRecoveredRejectedCasesSaga)
  yield takeEvery(patchRecoveredRejectedInfo.type, updateRecoveredRejectedInfoSaga)
}
